import { useRef, useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import CategoryBoard from "./components/CategoryBoard";
import Gallery from "./components/Gallery";
import Compare from "./components/Compare";
import Scenes from "./components/Scenes";
import Faq from "./components/Faq";
import AboutContact from "./components/AboutContact";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

function AnimatedSection({ children, className = "" }: { children: React.ReactNode; className?: string }) {
  const ref = useRef<HTMLDivElement>(null);
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!ref.current || !window.IntersectionObserver) return;
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setShow(true); },
      { threshold: 0.08 },
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  return (
    <div
      ref={ref}
      className={`transition-all duration-700 ease-out ${show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"} ${className}`}
    >
      {children}
    </div>
  );
}

export default function Home() {
  const [activeCategory, setActiveCategory] = useState("all");

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <AnimatedSection>
          <CategoryBoard onPick={setActiveCategory} />
        </AnimatedSection>
        <AnimatedSection>
          <Gallery activeCategory={activeCategory} setActiveCategory={setActiveCategory} />
        </AnimatedSection>
        <AnimatedSection>
          <Compare />
        </AnimatedSection>
        <AnimatedSection>
          <Scenes />
        </AnimatedSection>
        <AnimatedSection>
          <Faq />
        </AnimatedSection>
        <AnimatedSection>
          <AboutContact />
        </AnimatedSection>
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}